import { type IDynamicFieldsOptions } from '@pdqdev/pdq-shared/dist/interfaces/IDynamicFields';

export const AMOUNT_LEFT_TOKEN: IDynamicFieldsOptions = {
  name: '{amount-left}',
  searchTerm: 'amount-left',
  description: 'Extra amount the customer needs to pay to upgrade to the new product.',
  displayName: 'Amount left',
  category: 'Upgrade',
  replaceableName: null,
};

export const PRODUCT_NAME_TOKEN: IDynamicFieldsOptions = {
  name: '{product_name}',
  searchTerm: 'product_name',
  description: 'The cart product the upgrade offer is being shown for.',
  displayName: 'Product name',
  category: 'Upgrade',
  replaceableName: null,
};

export const DISCOUNT_DELTA_TOKEN: IDynamicFieldsOptions = {
  name: '{discount_delta}',
  searchTerm: 'discount_delta',
  description: 'Savings vs. the compare-at price of the upgrade option.',
  displayName: 'Discount delta',
  category: 'Upgrade',
  replaceableName: null,
};

export const DELIVERY_FREQUENCY_TOKEN: IDynamicFieldsOptions = {
  name: '{delivery_frequency}',
  searchTerm: 'delivery_frequency',
  description: "The subscription's billing/delivery interval, e.g. 'every 30 days'.",
  displayName: 'Delivery frequency',
  category: 'Upgrade',
  replaceableName: null,
};
